var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-nav-bar"},_vm._l((_vm.model.buttons),function(ref){
var id = ref.id;
var label = ref.label;
var icon = ref.icon;
var toast = ref.toast;
return _c('a',{key:id,staticClass:"dha-link menu-button",class:{
            selected: _vm.model.selected === id
        },attrs:{"href":"javascript:void(0);"},on:{"click":function () {
            if (_vm.model.selected === id) {
                _vm.model.selected = null;
                _vm.enableBodyScroll();
            } else {
                _vm.model.selected = id;
            }
        }}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(label))]),(icon)?_c('svg-inline',{class:(icon + "-icon"),attrs:{"src":(icon + "_icon")}}):_vm._e(),_c('div',{class:("toast " + (toast ? 'show' : ''))},[_vm._v(" "+_vm._s(toast)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }